import request from "@/utils/request";

export function robot_roles(data) {
    return request({
        url: '/chat/robot_roles',
        method: 'post',
        data
    });
}

export function save_robot_roles(data) {
    return request({
        url: '/chat/save_robot_roles',
        method: 'post',
        data
    });
}

export function all_robot_list(data) {
    return request({
        url: '/chat/all_robot_list',
        method: 'post',
        data
    });
}

export function chat_detail(data) {
    return request({
        url: '/chat/detail',
        method: 'post',
        data
    });
}

export function bind_client(data) {
    return request({
        url: '/chat/bind_client',
        method: 'post',
        data
    });
}

export function summary(data) {
    return request({
        url: '/chat/summary',
        method: 'post',
        data
    });
}

export function tts(data) {
    return request({
        url: '/chat/tts',
        method: 'post',
        data
    });
}

export function toggle_collapse(data) {
    return request({
        url: '/chat/toggle_collapse',
        method: 'post',
        data
    });
}

export function delete_chat(data) {
    return request({
        url: '/chat/delete_chat',
        method: 'post',
        data
    });
}

export function rename_chat(data) {
    return request({
        url: '/chat/rename_chat',
        method: 'post',
        data
    });
}
